/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, CircularProgress } from '@mui/material';
import LegacyGrid from './legacy/LegacyGrid';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFamilies, navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadManual';
import DropDownWithCheckBox from './DropDownWithCheckBox';
import './styles.css';
interface Props {
    next: any
    UpdateSelectedFamilies: Function
    selectedFamilies?: any
    UpdateSelectedProductNames: Function
    selectedProductNames?: any
    UpdateSelectedProductModels: Function
    selectedProductModels?: any
    selectedPdf?: any
    classes?: any,
    isDetailLoadingOnManualName: boolean
    UpdateUploadFamilies: Function
    uploadDetails: any
    FilterUploadNames: Function
    FilterUploadModels: Function
    selectedNameColors: any,
    selectedModelColors: any
}
const styles = () => ({
    input: {
        height: 35,
        width: 210
    },
    navigationButton: navigationButtonStyle
});

class ProductClassificationSelection extends React.Component<Props>{
    state = {
    };
    async componentDidMount() {
        const family = await getFamilies();
        this.props.UpdateUploadFamilies(family.data);
    }
    SelectFamily = async (selectedFamilies: any) => {
        if (this.props.uploadDetails.families !== undefined && selectedFamilies !== undefined) {
            this.props.UpdateSelectedFamilies(selectedFamilies);
            await this.props.FilterUploadNames(this.props.uploadDetails.families, selectedFamilies);
        }
    };
    SelectProductName = async (selectedProductNames: any) => {
        if (this.props.uploadDetails.productNames !== undefined && selectedProductNames !== undefined) {
            this.props.UpdateSelectedProductNames(selectedProductNames);
            await this.props.FilterUploadModels(this.props.uploadDetails.productNames, selectedProductNames);
        }
    };
    selectProductModel = (selectedProductModels: any) => {
        this.props.UpdateSelectedProductModels(selectedProductModels);
    };
    render() {
        const { classes } = this.props;
        let isDisabled = true, isNextDisabled = true, title = '';
        if (this.props.selectedPdf === undefined) {
            isDisabled = true;
            title = '1. Upload the Manual';
        }
        else {
            if (this.props.selectedProductModels !== undefined && this.props.selectedProductModels.length) {
                isNextDisabled = false;
            }
            isDisabled = false;
            title = '2. Assign the Manual';
        }
        return (
            <LegacyGrid className="classificationGrid" style={this.props.isDetailLoadingOnManualName ? { width: '45%' } : {}}>
                {this.props.uploadDetails.families &&
                    (
                        this.props.isDetailLoadingOnManualName ?
                            <div className="uploadClassificationInitial">
                                <CircularProgress color="secondary" />
                            </div>
                            :
                            <LegacyGrid>
                                <LegacyGrid className="classificationGridTitle">{title}</LegacyGrid>
                                <LegacyGrid className="classificationGridContents">
                                    <DropDownWithCheckBox title={'Product Family'} listValues={this.props.uploadDetails.families} UpdateSelectedValues={this.SelectFamily}
                                        disabled={isDisabled} isSelectOnlyOne={false} selectedValues={this.props.selectedFamilies} />
                                </LegacyGrid>
                                <LegacyGrid className="classificationGridContents">
                                    <DropDownWithCheckBox title={'Product Name'} listValues={this.props.uploadDetails.productNames} UpdateSelectedValues={this.SelectProductName}
                                    disabled={isDisabled} selectedValues={this.props.selectedProductNames} selectedColors={this.props.selectedNameColors}
                                    isSelectOnlyOne={false} />
                                </LegacyGrid>
                                <LegacyGrid className="classificationGridContents">
                                    <DropDownWithCheckBox title={'Product Model'} listValues={this.props.uploadDetails.productModels} UpdateSelectedValues={this.selectProductModel}
                                    disabled={isDisabled} selectedValues={this.props.selectedProductModels} selectedColors={this.props.selectedModelColors}
                                    isSelectOnlyOne={false} />
                                </LegacyGrid>
                            </LegacyGrid>
                    )
                }
                <LegacyGrid container justify="flex-end" className={this.props.isDetailLoadingOnManualName ? 'initialNavigationbuttonGrid' : 'navigatiobuttonGrid'}>
                    <Button className={classes.navigationButton} onClick={this.props.next} disabled={isNextDisabled}

                    >Next</Button>
                </LegacyGrid>
            </LegacyGrid>
        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedFamilies: state.uploadManual.selectedFamilies,
    selectedProductNames: state.uploadManual.selectedProductNames,
    selectedProductModels: state.uploadManual.selectedProductModels,
    selectedPdf: state.uploadManual.selectedPdf,
    isDetailLoadingOnManualName: state.uploadManual.isDetailLoadingOnManualName,
    uploadDetails: state.uploadManual.uploadDetails,
    selectedNameColors: state.uploadManual.selectedNameColors,
    selectedModelColors: state.uploadManual.selectedModelColors
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)
    (withStyles(styles)(ProductClassificationSelection));
